import { render, staticRenderFns } from "./industry_data.vue?vue&type=template&id=6b52973a&scoped=true"
import script from "./industry_data.vue?vue&type=script&lang=js"
export * from "./industry_data.vue?vue&type=script&lang=js"
import style0 from "./industry_data.vue?vue&type=style&index=0&id=6b52973a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52973a",
  null
  
)

export default component.exports